module.exports = __webpack_public_path__ + "static/img/rev_auto.1dfe0352.png";